module.exports = __webpack_public_path__ + "static/media/triangle-up.f1c239fc.svg";